import { useRegisterSW } from 'virtual:pwa-register/vue';

type TRegisterSWOptions = Parameters<typeof useRegisterSW>[0];
type TRegisterSWReturn = ReturnType<typeof useRegisterSW>;

let singleton: TRegisterSWReturn | undefined;

/**
 * Shared singleton wrapper around `useRegisterSW()` so the same service worker
 * registration/update state (`needRefresh`, `offlineReady`, `updateServiceWorker`) can
 * be read from anywhere - components or plain modules - instead of each caller owning
 * its own private registration. Only the first call's `options` take effect, since
 * `useRegisterSW()` itself only ever runs once.
 */
export function useServiceWorkerUpdates(options?: TRegisterSWOptions): TRegisterSWReturn {
  if (!singleton) {
    singleton = useRegisterSW(options);
  }
  return singleton;
}
